export default class ObjectUtils {
  /**
   * Filter the provided object using the provided predicate.
   *
   * @param {object} object original object
   * @param {function(object):boolean} predicate the predicate used to determine whether or not to
   * keep the current entry in the object
   * @return {object} the filtered object
   */
  static filter(object, predicate) {
    return Object.fromEntries(Object.entries(object).filter(predicate));
  }
}
